import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Form, Input, Button, Upload, message, Card } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import type { UploadChangeParam } from 'antd/es/upload';
import type { UploadFile } from 'antd/es/upload/interface';

// Upload props configuration
const uploadProps = {
  name: 'file',
  action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
  headers: {
    authorization: 'authorization-text',
  },
  onChange(info: UploadChangeParam<UploadFile>) {
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};

const Profile: React.FC = () => {
  const [form] = Form.useForm();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleFinish = (_values: Record<string, unknown>): void => {
    // TODO: Implement profile update API call
  };

  return (
    <div className="profile-container">
      <Container>
        <Row>
          <Col>
            <h2 className="page-heading">My Profile</h2>
            <Card>
              <Form form={form} className="profile-form" layout="vertical" onFinish={handleFinish}>
                <Row>
                  <Col md={4}>
                    <div className="profile-picture">
                      <img
                        src={require('../../img/login-art.png')}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                  </Col>
                  <Col md={8}>
                    <Upload {...uploadProps} className="mt-5 d-block">
                      <Button type="primary" icon={<UploadOutlined />}>
                        Click to Upload
                      </Button>
                    </Upload>
                  </Col>
                  <Col sm={12}>
                    <hr />
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <Form.Item label="First Name" name="firstName">
                      <Input placeholder="Enter First Name" />
                    </Form.Item>
                  </Col>
                  <Col sm={6}>
                    <Form.Item label="Last Name" name="lastName">
                      <Input placeholder="Enter Last Name" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <Form.Item label="Email" name="email">
                      <Input placeholder="Enter Email" />
                    </Form.Item>
                  </Col>
                  <Col sm={6}>
                    <Form.Item label="Phone Number" name="phone">
                      <Input placeholder="Enter Phone Number" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <Form.Item label="Address" name="address">
                      <Input placeholder="Enter Address" />
                    </Form.Item>
                  </Col>
                  <Col sm={6}>
                    <Form.Item label="Address 2" name="address2">
                      <Input placeholder="Enter Address 2" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <Form.Item label="City" name="city">
                      <Input placeholder="Enter City" />
                    </Form.Item>
                  </Col>
                  <Col sm={6}>
                    <Form.Item label="State" name="state">
                      <Input placeholder="Enter State" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col sm={6}>
                    <Form.Item label="Country" name="country">
                      <Input placeholder="Enter Country" />
                    </Form.Item>
                  </Col>
                  <Col sm={6}>
                    <Form.Item label="Zip Code" name="zipCode">
                      <Input placeholder="Enter Zip Code" />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Item className="gx-text-center">
                      <Button type="primary" htmlType="submit">
                        Update
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Profile;
